export enum PorchType {
  AwningStyle = 'awning-style',
  GableEndEnclosed = 'gable-end-enclosed',
  GableEndCeilingBeams = 'gable-end-ceiling-beams',
  GableEndOpen = 'gable-end-open',
  GableEndOpenCrossbar = 'gable-end-crossbar',
  GableEndOpenStarburst = 'gable-end-starburst',
  // 🤔 hmm. can we find a way to get rid of None, or have it supported generically across all optionAttributes?
  None = 'none',
  // Non-visual is used for porches that aren't supported by the 3D code yet, but vendors still
  // want to show them as an option in the configurator so customers can see the pricing
  NonVisual = 'non-visual',
}
